import { render, staticRenderFns } from "./106.vue?vue&type=template&id=484c964c&scoped=true"
import script from "./106.vue?vue&type=script&lang=js"
export * from "./106.vue?vue&type=script&lang=js"
import style0 from "./106.vue?vue&type=style&index=0&id=484c964c&prod&lang=less&scoped=true"
import style1 from "./106.vue?vue&type=style&index=1&id=484c964c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484c964c",
  null
  
)

export default component.exports